import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/i18n/fr/app.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eccb9eb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eccb9eb4', __exports__)) {
    api.reload('eccb9eb4', __exports__)
  }
  
}


export default __exports__